import { gql } from '@apollo/client';

export const CREATE_LOCATION = gql`
  mutation createLocation($doc: LocationInput!) {
    createLocationEntity(doc: $doc) {
      id
    }
  }
`;

export const UPDATE_LOCATION = gql`
  mutation updateLocation($updatedDoc: LocationInput!, $filter: LocationInput!) {
    updateLocationEntity(updatedDoc: $updatedDoc, filter: $filter) {
      id
    }
  }
`;

export const UPDATE_CREATE_USERS_LOCATION = gql`
  mutation createOrUpdateUsersLocations($updatedDocs: [UsersLocationsInput!]!, $filters: [UsersLocationsInput!]!) {
    createOrUpdateManyUsersLocationsEntity(updatedDocs: $updatedDocs, filters: $filters) {
      id
    }
  }
`;

export const DELETE_USERS_LOCATIONS = gql`
  mutation deleteManyUsersLocationsEntity($ids: [String!]!) {
    deleteManyUsersLocationsEntity(ids: $ids) {
      message
    }
  }
`;
